import { render, staticRenderFns } from "./IntroductionBenefit.vue?vue&type=template&id=457e2862&"
import script from "./IntroductionBenefit.vue?vue&type=script&lang=js&"
export * from "./IntroductionBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports